/* eslint-disable @typescript-eslint/no-explicit-any */

import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { LoggerService } from './logger.service';
import { LogEvent } from '../enums/log-event';
import * as Sentry from "@sentry/angular-ivy";
import { getLocalstorageSizes } from 'src/app/modules/live-chat/helpers/localstorage-sizes';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService implements ErrorHandler {
  constructor(private loggerService: LoggerService, private ngZone: NgZone) {}

  public handleError(error: any): void {
    console.error(error)

    
    this.loggerService.error(LogEvent.LIVECHAT_GLOBAL_ERROR, error)
    
    this.ngZone.runOutsideAngular(()=>{
      Sentry.createErrorHandler({
        showDialog: false,
        logErrors: false,
      }).handleError(error);
    })

    if(error.name === 'QuotaExceededError') {
      this.loggerService.log(LogEvent.LIVECHAT_LOCALSTORAGE_QUOTA, getLocalstorageSizes())
    }
  }
}
